export default {
    mensajes: {
      inicial: '¡Hola!',
      descripcion: 'En tres pasos, podrás solicitar tu presupuesto de forma sencilla y rápida.',
      resumen: 'Ver Resumen',
     
      datos_de_reserva: 'Datos de reserva',
      datos_personales: 'Datos personales',
      resumen_reserva: 'Presupuesto enviado',

      preguntaPaso1: 'Necesitamos los datos básicos para gestionar el camino, como son: fecha de llegada, cantidad de peregrinos y cantidad de habitaciones por tipo.',
      datos_reserva: {
        fechas_seleccion: 'Fecha de llegada y salida',

        habitaciones_individuales: 'Habitaciones Individuales',
        habitaciones_dobles: 'Habitaciones Dobles (2_camas_individuales)',
        habitaciones_dobles_matrimoniales: 'Habitaciones Dobles (cama_matrimonial)',
        habitaciones_triples: 'Habitaciones Triples',
        cantidad_de_peregrinos: 'Cantidad de peregrinos',

        titulo: 'Datos de la reserva',
        fecha_inicio: 'Fecha de llegada:',
        fecha_llegada: 'Fecha de salida:',
        habitaciones: 'Habitaciones:',
        peregrinos: 'Peregrinos:',
        comentarios: 'Cuéntanos cualquier detalle adicional.\n¿Vienes con niños? Dinos sus edades.\n¿Traes mascotas? Indícanos qué mascota es y su peso.',
      
        importe_reserva: 'Importe reserva:',
        servicios_agregados: 'Servicios agregados:',
        importe_total: 'Importe total:',
        comision_agencia: '15% Comisión Agencia:',
        importe_neto_agencia: 'Importe Neto Agencia:',
        no_comisionable: '(No comisionable)',
        precio_por_peregrino: '€/Peregrino',
      },

      servicios: {
        tab_servicios: 'Servicios',
        incluidos_titulo: 'Servicios incluidos',
        incluidos_subtitulo: 'Si quieres cancelar alguno de los servicios incluidos, puedes eliminarlo.',
        opcionales_titulo: 'Servicios opcionales',
        pendiente_de_tarifa: 'Pendiente de tarifa',
        subtitulo_desde: '(Desde {tarifa}€)',
        subtitulo_por_persona: '({tarifa}€ x persona)',
        subtitulo_por_persona_con_persona: '({tarifa}€ x {personas} personas)',
        noche_extra_en: 'Noche extra en',
        traslado_extra: 'Traslado extra',
        servicio_extra: 'Servicio extra',
        ver_incluidos_boton: 'Ver servicios incluidos',
      },

      siguientePaso1: 'Siguiente',

      preguntaPaso2: 'Ahora, necesitamos tus datos para poder enviarte el presupuesto lo antes posible.',
      nombre: 'Nombre',
      apellidos: 'Apellidos',
      telefono: 'Teléfono',
      email: 'Email',

      politica_privacidad: 'He leído y acepto la ',
      politica_privacidad_texto_enlace: 'política de privacidad',
      politica_privacidad_enlace: 'https://rutasmeigas.com/es/politica-privacidad',

      acepta_novedades: 'Acepto recibir noticias y novedades.',
      
      recibir_presupuesto: 'Recibir presupuesto',
      enviando_presupuesto: 'Enviando presupuesto...',
      presupuesto_enviado: 'Presupuesto enviado!',
      
      
    datos_pasajeros: {
      titulo: 'De acuerdo la legislación actual española (Real Decreto 933/2021 de 26 de octubre) por la que se establecen las obligaciones de registro documental e información de personas físicas o jurídicas que ejercen actividades de hospedaje (agencias de viajes, establecimientos hoteleros y empresas de alquiler de vehículos) debemos facilitar los siguientes datos al Ministerio del Interior (Gobierno de España).',
      subtitulo: 'Para gestionar tu reserva, necesitamos los datos completos de todos los peregrinos que realizarán el Camino de Santiago. Por favor, rellena cada formulario con la información solicitada.<br>Es importante que los datos sean precisos y estén completos, ya que los utilizaremos para la organización del viaje, la reserva de alojamientos y otros servicios.<br>Una vez hayas completado toda la información, procederemos a confirmar tu reserva. Si tienes alguna duda, no dudes en contactarnos.',
      datos_peregrino: 'Viajero {index}',
      confirmar_datos: 'Confirmar datos',
      guardar_datos: 'Guardar datos de los viajeros',
      mensaje_final_success: 'Gracias. Los datos de los viajeros han sido guardados correctamente.',
      pagar: 'Pagar',
      mensaje_confirmacion_pasajero_y_pago: 'Sus datos han sido enviados correctamente. Le informamos que el importe total de la reserva es de {importe} €.<br>Ya puede efectuar un pago anticipado de la reserva de 100€.',
      pago_realizado: 'Pago realizado correctamente',

      nombre: 'Nombre',
      primer_apellido: 'Primer Apellido',
      segundo_apellido: 'Segundo Apellido',
      sexo: 'Sexo',
      sexo_opciones: {
        hombre: 'Hombre',
        mujer: 'Mujer',
        no_decir: 'Prefiero no decirlo',
      },
      fecha_nacimiento: 'Fecha de Nacimiento',
      tipo_documento: 'Tipo de Doc.',
      tipo_documento_opciones: {
        dni: 'DNI',
        nie: 'NIE',
        pasaporte: 'PASAPORTE',
      },
      numero_documento: 'Número de Documento',
      soporte_documento: 'Soporte de Documento',
      telefono_fijo: 'Teléfono Fijo',
      telefono_movil: 'Teléfono Móvil',
      email: 'Email',
      direccion: 'Dirección',
      poblacion: 'Población',
      provincia: 'Provincia',
      codigo_postal: 'Código Postal',
      nacionalidad: 'Nacionalidad',
      parentesco: 'Parentesco',
     

      pago_realizado_subtitulo: 'Gracias por confiar en nosotros.<br>Nos pondremos en contacto contigo para confirmar los detalles de tu reserva.',
      politica_privacidad: `Responsable del tratamiento: RUTAS MEIGAS SL CIF: B15649270 Dir. Postal: LUGAR DO BARCO 1, 15917 - PADRON (A CORUÑA) Teléfono: 881019941 Correo electrónico: info@rutasmeigas.com 
Finalidad del tratamiento de sus datos: De acuerdo a lo establecido en la legislación vigente en materia de Protección de Datos de Carácter Personal, Reglamento 2016/679 General de Protección de Datos (RGPD) y la Ley Orgánica 3/2018 de 5 de diciembre, de protección de datos de carácter personal y garantía de los derechos digitales (LOPDGDD), le indicamos que la finalidad del tratamiento de sus datos es llevar a cabo la gestión de su reserva.
Legitimación: Artículo 6.1.a) del RGPD. El interesado dio su consentimiento para el tratamiento de sus datos personales para uno o varios fines específicos. Artículo 6.1.b) del RGPD. Tratamiento necesario para la ejecución de un contrato en el que el interesado es parte o para la aplicación a petición de éste de medidas precontractuales. Artículo 6.1.c) del RGPD: el tratamiento es necesario para el cumplimiento de una obligación legal aplicable al responsable del tratamiento: - Real Decreto 933/2021, de 26 de octubre, por el que se establecen las obligaciones de registro documental e información de las personas físicas o jurídicas que ejercen actividades de hospedaje y alquiler de vehículos a motor.
Conservación y tratamiento de los datos: Los datos proporcionados se conservarán mientras no solicite la cancelación de la misma, o durante el tiempo necesario para cumplir con las obligaciones legales y atender las posibles responsabilidades que pudieran derivar del cumplimiento de la finalidad para la que los datos fueron recabados. Sus datos serán cedidos a las diferentes empresas mayoristas con las que la entidad opere, así como a las compañías aéreas, establecimientos hoteleros, empresas de alquiler de vehículos y/o tour operadores, en su caso, con los fines de contratar los servicios de estos o de solicitar información tanto de disponibilidad como de precios. Estos proveedores, dependiendo del país de destino de su viaje, podrán estar ubicados en países que no tengan un nivel de protección de datos similar al existente en la UE, para los cuales la cesión es necesaria para la finalidad de la ejecución de medidas contractuales. Podrán ser cedidos igualmente a otras empresas con las que RUTAS MEIGAS SL trabaje/colabore con el fin de llevar a cabo las gestiones y/o servicios correspondientes. Otros datos no serán cedidos a terceros salvo en los casos en que exista una obligación legal. RUTAS MEIGAS SL no elaborará ningún tipo de "perfil" en base a la información facilitada. No se tomarán decisiones automatizadas en base a perfiles.
Derechos: Usted podrá ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, portabilidad de datos y a no ser objeto de decisiones individualizadas automatizadas, en relación con los datos objeto del tratamiento, ante el responsable del tratamiento en la dirección RÚA LISBOA 16 BAJO IZDA - 15707 - SANTIAGO DE COMPOSTELA, adjuntando copia de su DNI o documento equivalente. En caso de que no haya obtenido satisfacción en el ejercicio de sus derechos, puede presentar una reclamación ante la Autoridad de Control en materia Protección de Datos competente, siendo ésta la Agencia Española de Protección de Datos.`
   
    },

    ir_al_camino: 'Más detalles del Camino',

    enviar_consulta: 'Enviar',
    texto_consulta_agencia: 'Envíanos tu consulta y nos pondremos en contacto contigo lo antes posible.',
    consulta_enviada: 'Ya hemos recibido tu consulta, te contactaremos lo antes posible. Gracias!',
                                    
                       
   
   
    },
    
  }
